import { Video, kinoParticipants } from "../../libs/roomnew";
import { MEDIA_TYPE } from "../base/tracks/constants";
import { getLocalTrack, getRemoteParticipantTrack } from "../base/tracks/functions";
// import {Draggable} from '@shopify/draggable';
import interact from 'interactjs'
export function enableScreenshareView(p) {
    try{
        const desktopTrack=p.local ? getLocalTrack(MEDIA_TYPE.SCREENSHARE) : getRemoteParticipantTrack(p.id,MEDIA_TYPE.SCREENSHARE);
        const cameraTrack=p.local ? getLocalTrack(MEDIA_TYPE.VIDEO) : getRemoteParticipantTrack(p.id,MEDIA_TYPE.VIDEO);
        console.log("enableScreenshareView",p,desktopTrack,cameraTrack)
        if(cameraTrack && !cameraTrack.kinoTrack?.isMuted()){
            createSmallPlayer(p);
            attachTrackToSmallPlayer(p,cameraTrack);
        }
        attachTrackToLargePlayer(p,desktopTrack);

    } catch (e){
        console.error(e)
    }
}

export function disableScreenshareView(p) {
    try{
        const cameraTrack=p.local ? getLocalTrack(MEDIA_TYPE.VIDEO) : getRemoteParticipantTrack(p.id,MEDIA_TYPE.VIDEO);
        removeSmallPlayer(p);
        attachTrackToLargePlayer(p,cameraTrack);
    } catch (e){
        console.error(e)
    }
}


export function attachTrackToSmallPlayer(p,track) {
    console.log("attachTrackToSmallPlayer",p,track)
    if(!track){
        return;
    }

    if(p.local){
        Video.localVideo.smallPlayer || createSmallPlayer(p);
        Video.localVideo.smallPlayer.mediaElement.srcObject=track?.kinoTrack?.stream;
    }else{
        Video.videos[p.id].smallPlayer || createSmallPlayer(p);
        Video.videos[p.id].smallPlayer.mediaElement.srcObject=track?.kinoTrack?.stream;
    }
}

export function attachTrackToLargePlayer(p,track) {
    console.trace("attachTrackToLargePlayer",p,track)
    if(p.local){
        document.getElementById(`localVideo1`).srcObject=track?.kinoTrack?.stream;
        // Video.localVideo.player.srcObject=track?.kinoTrack?.stream;
    }else{
        if(Video.videos[p.id]?.showLoadingSpinner){
            Video.videos[p.id].showLoadingSpinner();
        }
        Video.videos[p.id].player.srcObject=track?.kinoTrack?.stream;
        document.querySelectorAll(`.conversation-video-player[pid="${p.id}"]`).forEach(element=>{
            element.srcObject=track?.kinoTrack?.stream;
        });
    }
}

export function removeSmallPlayer(p) {
    try {
        if(p.local){
            // Video.localVideo.smallPlayer.draggable.destroy()
            if(Video.localVideo.smallPlayer){
                Video.localVideo.smallPlayer.mediaElement.srcObject=null;
                Video.localVideo.smallPlayer.wrapper.remove();
                Video.localVideo.smallPlayer=null;
            }
            Video.localVideo.wrapper.removeClass('multi-video');
        }else{
            // Video.videos[p.id].smallPlayer.draggable.destroy()
            if(Video.videos[p.id].smallPlayer){
                Video.videos[p.id].smallPlayer.mediaElement.srcObject=null;
                Video.videos[p.id].smallPlayer.wrapper.remove();
                Video.videos[p.id].smallPlayer=null;
            }
            Video.videos[p.id].wrapper.removeClass('multi-video');
        }
    } catch (error) {
        console.error("Remove small player error",error)
    }
}

export function onResizeScreen(){
    try {
        console.log("Screenshare UI onResizeScreen")
        const sameSpaceParticipants = kinoParticipants.inSameSpace();
        sameSpaceParticipants.forEach(p=>{
            reflowDragableVideo(p.id);
        })
    } catch (error) { console.error("[Kino Error] [ScreenshareUI]", error); }
}

export function reflowDragableVideo(pid){
    try {
        const p = kinoParticipants.get(pid);
        if(p.local){
            if(Video.localVideo.smallPlayer){
                requestAnimationFrame(() => rescaleSmallPlayerPosition(Video.localVideo.smallPlayer));
            }
        }else{
            if(Video.videos[p.id].smallPlayer){
                requestAnimationFrame(() => rescaleSmallPlayerPosition(Video.videos[p.id].smallPlayer));
            }
        }
    } catch (error) { console.error("[Kino Error] [ScreenshareUI]", error); }
}

export function createSmallPlayer(p){
    if(p.local && Video.localVideo.smallPlayer){
        return;
    }else if(!p.local && Video.videos[p.id].smallPlayer){
        return;
    }
    const data = {};
    data.mediaElement=document.createElement('video');
    data.mediaElement.setAttribute("autoplay",1);
    data.mediaElement.id=`${p.id}-small-player`;
    data.mediaElement.className="small-player";

    data.mediaElement.onplaying = (event) => {
        console.log(p.name+" small player started playing.");
    };
    //begin card 808
    data.mediaElement.oncanplay=(event)=>{
        data.mediaElement.play();
    };
    data.wrapper = $('<div/>', {
        class: 'small-player-wrapper',
        html:[ data.mediaElement]
    });
    data.draggable =  interact(data.wrapper[0]).draggable({
        inertia: true,
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ],
        autoScroll: true,
        listeners: {
          move: dragMoveListener,
          end (event) {
          }
        }
      });


    // = new Draggable(p.local ? Video.localVideo.wrapper[0] : Video.videos[p.id].wrapper[0], {
    //     draggable: data.wrapper[0],
    //     exclude: {
    //         plugins: [Draggable.Plugins.Mirror],
    //     }
    // });

    // data.draggable.on('drag:start', () => console.log('drag:start'));
    // data.draggable.on('drag:move', (e) => console.log('drag:move',e));
    // data.draggable.on('drag:stop', (e) => console.log('drag:stop',e));

    if(p.local){
        Video.localVideo.smallPlayer=data
        Video.localVideo.wrapper.append(data.wrapper);
        Video.localVideo.wrapper.addClass('multi-video');
    }else{
        Video.videos[p.id].smallPlayer=data
        Video.videos[p.id].wrapper.append(data.wrapper);
        Video.videos[p.id].wrapper.addClass('multi-video');
    }

}


// target elements with the "draggable" class
interact('.draggable')
  .draggable({
    inertia: true,
    modifiers: [
      interact.modifiers.restrictRect({
        restriction: 'parent',
        endOnly: true
      })
    ],
    autoScroll: true,
    listeners: {
      move: dragMoveListener,
      end (event) {
      }
    }
  })

function rescaleSmallPlayerPosition(smallPlayer) {
  try {
    var wrapper = smallPlayer.wrapper[0]
    var parent = wrapper.parentElement
    if (!parent) return

    var parentRect = parent.getBoundingClientRect()
    var wrapperRect = wrapper.getBoundingClientRect()
    var currentX = parseFloat(wrapper.getAttribute('data-x')) || 0
    var currentY = parseFloat(wrapper.getAttribute('data-y')) || 0

    var cssOffsetLeft = (wrapperRect.left - parentRect.left) - currentX
    var cssOffsetTop = (wrapperRect.top - parentRect.top) - currentY

    var maxX = parentRect.width - wrapperRect.width
    var maxY = parentRect.height - wrapperRect.height

    var relX = parseFloat(wrapper.getAttribute('data-rel-x'))
    var relY = parseFloat(wrapper.getAttribute('data-rel-y'))

    var newX, newY
    if (!isNaN(relX) && !isNaN(relY)) {
      var targetLeft = Math.max(0, Math.min(relX, 1)) * Math.max(0, maxX)
      var targetTop = Math.max(0, Math.min(relY, 1)) * Math.max(0, maxY)
      newX = targetLeft - cssOffsetLeft
      newY = targetTop - cssOffsetTop
    } else {
      newX = currentX
      newY = currentY
    }

    var minX = -cssOffsetLeft
    var maxTranslateX = Math.max(0, maxX) - cssOffsetLeft
    var minY = -cssOffsetTop
    var maxTranslateY = Math.max(0, maxY) - cssOffsetTop
    newX = Math.max(minX, Math.min(newX, maxTranslateX))
    newY = Math.max(minY, Math.min(newY, maxTranslateY))

    wrapper.setAttribute('data-x', newX)
    wrapper.setAttribute('data-y', newY)
    wrapper.style.transform = 'translate(' + newX + 'px, ' + newY + 'px)'

    wrapper.setAttribute('data-rel-x', maxX > 0 ? (cssOffsetLeft + newX) / maxX : 0)
    wrapper.setAttribute('data-rel-y', maxY > 0 ? (cssOffsetTop + newY) / maxY : 0)
  } catch (e) {
    console.error("[Kino Error] [ScreenshareUI] rescaleSmallPlayerPosition", e)
  }
}

function dragMoveListener (event) {
  var target = event.target
  var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
  var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

  target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

  target.setAttribute('data-x', x)
  target.setAttribute('data-y', y)

  if (target.classList.contains('small-player-wrapper') && (event.dx !== 0 || event.dy !== 0)) {
    var parent = target.parentElement
    if (parent) {
      var parentRect = parent.getBoundingClientRect()
      var targetRect = target.getBoundingClientRect()
      var maxX = parentRect.width - targetRect.width
      var maxY = parentRect.height - targetRect.height
      target.setAttribute('data-rel-x', maxX > 0 ? (targetRect.left - parentRect.left) / maxX : 0)
      target.setAttribute('data-rel-y', maxY > 0 ? (targetRect.top - parentRect.top) / maxY : 0)
    }
  }
}
